<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/learning-content-type/" restUrl="api/lrn/learningcontenttype">
</crud-list>
